import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";

/**
 * 小红书平台标签组件
 * 包含所有小红书相关的标签逻辑
 */
export default function useXhsTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.XHS_HOME_DELIVERY)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.XHS_HOME_DELIVERY}
                orderTag={OrderTag.XHS_HOME_DELIVERY}
            />,
        );
    }

    return icons;
}
